import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const dashboard = createApi({
    reducerPath: "dashboard",
    baseQuery: dynamicBaseQuery,
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        dashboard: builder.query({
            query: (selectedTeam) => {
                return {
                    url: `v1/common/dashboard/?team=${selectedTeam}&`,
                    method: "GET",
                };
            },
        }),

        workflow: builder.query({
            query: (selectedWorkFlow) => {
                return {
                    url: `v1/tickets/bin-count/workflow/${selectedWorkFlow}/?`,
                    method: "GET",
                };
            },
        }),

        channelWiseTicket: builder.query({
            query: ({ selectTeam, selectWorkFlow, graphStartDate, graphEndDate }) => {
                return {
                    url: `/v1/common/ticket-channel-count/?type=ticket_to_channel&team=${selectTeam}&workflow=${selectWorkFlow}&start_date=${graphStartDate}&end_date=${graphEndDate}&`,
                    method: "GET",
                };
            },
        }),

        ticketInterval: builder.query({
            query: ({
                selectedTeam,
                selectedWorkFlow,
                graphStartDate,
                graphEndDate,
            }) => {
                return {
                    url: `v1/common/dashboard/ticket-volume/?team=${selectedTeam}&workflow=${selectedWorkFlow}&start_date=${graphStartDate}&end_date=${graphEndDate}&`,
                    method: "GET",
                };
            },
        }),

        ticketWorkflow: builder.query({
            query: (selectedTeam) => {
                return {
                    url: `v1/tickets/ticket-name/?team=${selectedTeam}&`,
                    method: "GET",
                };
            },
        }),

        ticketWorkflowId: builder.query({
            query: (selectedTeam) => {
                return {
                    url: `v1/tickets/ticket-name/?team_id=${selectedTeam}&`,
                    method: "GET",
                };
            },
        }),

        // Email Dashboard
        emailVolume: builder.query({
            query: ({
                email_type = "active", // default to "active" if not provided
                start_date,
                end_date,
                team,
            }) => {
                return {
                    url: `v1/common/dashboard/email-volume/`,
                    method: "GET",
                    params: {
                        email_type: email_type === "active" ? "sent" : "received", // conditional check
                        start_date,
                        end_date,
                        team,
                    },
                };
            },
        }),

        ticketVolume: builder.query({
            query: ({ email_type, start_date, end_date, team_id }) => {
                return {
                    url: `v1/common/dashboard/ticket-volume/`,
                    method: "GET",
                    params: {
                        email_type,
                        start_date,
                        end_date,
                        team_id,
                    },
                };
            },
        }),

        getAllDashboardData: builder.query({
            query: ({ start_date, end_date, team, dashboard_type, workflow_id }) => {
                return {
                    url: `v1/common/new-dashboard/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team,
                        dashboard_type,
                        workflow_id,
                    },
                };
            },
        }),

        disposition: builder.query({
            query: (teamId) => ({
                url: `v1/common/dashboard/top_dispositions/?&team_id=${teamId}`,
                method: "GET",
            }),
        }),
        getAllCampaignDashboardData: builder.query({
            query: ({
                start_date,
                end_date,
                team,
                dashboard_type,
                campaign,
                outwardLeadButton,
            }) => {
                console.log(outwardLeadButton, "campaiggigi");
                const campaign_type = outwardLeadButton ? "outward" : "inward";

                // const campaign_type = campaignType === "true" ? "outward" : "inward"
                return {
                    url: `v1/common/new-dashboard/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team,
                        dashboard_type,
                        campaign,
                        campaign_type,
                    },
                };
            },
        }),
        getAllCampaignDashboardDataSummary: builder.query({
            query: ({
                start_date,
                end_date,
                team,
                dashboard_type,
                outwardLeadButton,
            }) => {
                const campaign_type = outwardLeadButton ? "outward" : "inward";

                return {
                    url: `v1/common/new-dashboard/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team,
                        dashboard_type,
                        campaign_type,
                    },
                };
            },
        }),

        getFilterBundle: builder.query({
            query: () => {
              const team_id = localStorage.getItem("teamId");
      
              return {
                url: `v1/common/leadDashboard/filter-bundle/campaign?`,
                method: "GET",
                params: {
                  team_id,
      
                },
              };
            }
          }),
        getFilterAssigneeByCampaignId: builder.query({
            query: ({ campaign_id }) => {
                console.log(campaign_id, "campaignId");
                return {
                    url: `v1/common/leadDashboard/filter-bundle/assignee?campaign_id=${campaign_id}`,
                    method: "GET",

                };
            }
        }),

        getCampaignTeamPerformanceData: builder.query({
            query: ({
                start_date,
                end_date,
                campaign_id,
            }) => {
                return {
                    url: `v1/common/leadDashboard/team-performance/?`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        campaign_id,

                    },
                };
            },
        }),

        getCampaignTasksData: builder.query({
            query: ({
                start_date,
                end_date,
                campaign_id,
            }) => {
                return {
                    url: `v1/common/leadDashboard/completed-tasks-over-time/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        campaign_id,

                    },
                };
            },
        }),

        getCampaignLeadAnalysisData: builder.query({
            query: ({
                start_date,
                end_date,
                campaign_id,
            }) => {
                return {
                    url: `v1/common/leadDashboard/lead-analysis-bundle/?`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        campaign_id,
                    },
                };
            },
        }),
        getLeadClickToExpand: builder.query({
            query: ({
                start_date,
                end_date,
                campaign_id,
                graph_name,
                value,
                status_type,
                team_id,
                template_id,
                page = 1,
                page_size = 10,
            }: {
                start_date: string;
                end_date: string;
                campaign_id?: string | number;
                graph_name: string;
                value: string;
                status_type?: string;
                team_id?: string | number | null;
                template_id?: string | number | null;
                page?: number;
                page_size?: number;
            }) => {
                const params: Record<string, string | number> = {
                    start_date,
                    end_date,
                    graph_name,
                    value,
                    page,
                    page_size,
                };
                if (campaign_id != null && campaign_id !== "") params.campaign_id = campaign_id;
                if (team_id != null && team_id !== "") params.team_id = team_id;
                if (status_type != null) params.status_type = status_type;
                if (template_id != null && template_id !== "") params.template_id = template_id;
                return {
                    url: `v1/common/leadDashboard/click-to-expand/`,
                    method: "GET",
                    params,
                };
            },
        }),
        getEmailFirstResponseClickToExpand: builder.query({
            query: ({
                graph_name,
                value,
                start_date,
                end_date,
                team_id,
                page,
                page_size,
                email_type,
            }: {
                graph_name: string;
                value: string;
                start_date: string;
                end_date: string;
                team_id: string | number;
                page?: number;
                page_size?: number;
                email_type?: string;
            }) => {
                const params: Record<string, string | number> = {
                    graph_name,
                    value,
                    start_date,
                    end_date,
                    team: team_id,
                    page: page ?? 1,
                    page_size: page_size ?? 20,
                };
                if (email_type != null && email_type !== "") params.email_type = email_type;
                return {
                    url: `v1/common/emailDashboard/click-to-expand/`,
                    method: "GET",
                    params,
                };
            },
        }),


        getEmailDashboardData: builder.query({
            query: ({
                start_date,
                end_date,
                team,
            }) => {
                return {
                    url: `v1/common/emailDashboard/overview/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team,
                        email_type: "sent",

                    },
                };
            },
        }),
        getEmailDashboardPerformanceData: builder.query({
            query: ({
                start_date,
                end_date,
                team,
            }) => {
                return {
                    url: `v1/common/emailDashboard/performance/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team,
                    },
                };
            },
        }),
        getEmailDashboardAnalyticsData: builder.query({
            query: ({
                start_date,
                end_date,
                team,
            }) => {
                return {
                    url: `v1/common/emailDashboard/analytics/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team,
                    },
                };
            },
        }),

        getWhatsappVolume: builder.query({
            query: ({
                start_date,
                end_date,
                team_id,
                campaign_id,
                campaign_type = "outward",
                template_id,
            }: {
                start_date: string;
                end_date: string;
                team_id: string | number;
                campaign_id: string | number;
                campaign_type?: string;
                template_id?: string | number;
            }) => {
                return {
                    url: `v1/common/leadDashboard/whatsapp-volume/`,
                    method: "GET",
                    params: {
                        start_date,
                        end_date,
                        team_id,
                        campaign_id,
                        campaign_type,
                        template_id,
                    },
                };
            },
        }),
    }),
});

export const {
    useTicketWorkflowIdQuery,
    useDashboardQuery,
    useGetAllCampaignDashboardDataQuery,
    useGetAllCampaignDashboardDataSummaryQuery,
    useWorkflowQuery,
    useChannelWiseTicketQuery,
    useTicketIntervalQuery,
    useTicketWorkflowQuery,
    useEmailVolumeQuery,
    useGetAllDashboardDataQuery,
    useDispositionQuery,
    useGetFilterBundleQuery,
    useGetCampaignTeamPerformanceDataQuery,
    useGetCampaignTasksDataQuery,
    useGetCampaignLeadAnalysisDataQuery,
    useGetFilterAssigneeByCampaignIdQuery,
    useGetLeadClickToExpandQuery,
    useGetEmailFirstResponseClickToExpandQuery,
    useGetEmailDashboardDataQuery,
    useGetEmailDashboardPerformanceDataQuery,
    useGetEmailDashboardAnalyticsDataQuery,
    useGetWhatsappVolumeQuery } = dashboard;